import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import MiniLayout from "./NavbarBox/MiniLayout";

const PrivateRoute = ({ element: Component, withLayout = false, ...rest }) => {
  const token = useSelector((state) => state.auth.employeeDetails?.token);

  if (!token) {
    return <Navigate to="/" />;
  }

  if (!token) {
    return <Navigate to="/" />;
  }

  return withLayout && (
    <MiniLayout>
      <Component {...rest} />
    </MiniLayout>
  )
};

export default PrivateRoute;
